import { render, staticRenderFns } from "./ProductReviewList.vue?vue&type=template&id=3720e524&scoped=true"
import script from "./ProductReviewList.vue?vue&type=script&lang=js"
export * from "./ProductReviewList.vue?vue&type=script&lang=js"
import style0 from "./ProductReviewList.vue?vue&type=style&index=0&id=3720e524&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3720e524",
  null
  
)

export default component.exports